import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OxioAdminBrandService {
  /**
   * Get OXIO Admin branduuid from local storage
   * @method getToken
   * @returns {string} OXIO Admin branduuid
   */
  getBrandUuid(): string {
    return window.localStorage['oxioAdminBrandUuid'];
  }

  /**
   * Save OXIO Admin branduuid to local storage
   * @method saveBrandUuid
   * @param token OXIO Admin branduuid
   */
  saveBrandUuid(token: string) {
    window.localStorage['oxioAdminBrandUuid'] = token;
  }

  /**
   * Destroy OXIO Admin branduuid in local storage
   * @method destroyBrandUuid
   */
  destroyBrandUuid() {
    window.localStorage.removeItem('oxioAdminBrandUuid');
  }
}
